// extracted by mini-css-extract-plugin
export default {"hero":"HeroImage_hero__niZCd"};